import { TPreparedAcceptSettingsColumns } from 'shared/types/vacation-schedule.types';

export const VACATION_SCHEDULE_ACCEPT_SETTINGS_COLUMN: TPreparedAcceptSettingsColumns = [
  {
    title: 'Подразделение',
    dataIndex: 'division',
    key: 'division',
  },
  {
    title: 'Руководитель',
    dataIndex: 'fio',
    key: 'fio',
  },
  {
    title: 'Количество этапов согласования',
    dataIndex: 'agreementDepth',
    key: 'agreementDepth',
  },
];
